// extracted by mini-css-extract-plugin
export default {"bg":"EventPage_bg__vRG+5","page":"EventPage_page__K0NlP","bgMobile":"EventPage_bgMobile__hAiS6"};